export const normalizeUnitType = (unitName: string): string => {
  if (!unitName) return ""
  const normalized = unitName.trim().toLowerCase()
  
  if (normalized.includes("adet") || normalized.includes("piece")) return "Piece"
  if (normalized === "kg" || normalized.includes("kilogram")) return "KG"
  if (normalized === "ton") return "Ton"
  if (normalized.includes("metre") || normalized.includes("meter")) return "Meter"
  if (normalized.includes("m²") || normalized.includes("metrekare") || normalized.includes("square meter")) return "m²"
  
  return unitName // Fallback to original
}
